/**
 * @generated SignedSource<<a7845509064743e4a0e47814b9ea041f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryPaneTitle_item$data = {
  readonly skus: ReadonlyArray<{
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ImageMultiSkuOverlay_sku">;
  } | null> | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSummaryItemSkuDetails_item" | "ImageMultiSkuOverlay_item">;
  readonly " $fragmentType": "CheckoutMobileSummaryPaneTitle_item";
};
export type CheckoutMobileSummaryPaneTitle_item$key = {
  readonly " $data"?: CheckoutMobileSummaryPaneTitle_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryPaneTitle_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryPaneTitle_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ImageMultiSkuOverlay_sku"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ImageMultiSkuOverlay_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSummaryItemSkuDetails_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "3ae48d8a5a065abe34fb54afe920744f";

export default node;
